import { Message } from "element-ui";
import qs from "qs";
import avatar from "@/graphql/avatar";

const state = {
  avatarData: '',
  avatarLoading: true,
  avatarDialog: false,
};
const getters = {};
const actions = {
  getAvatar({ state, commit }) {
      state.avatarLoading = true;
      apolloProvider.clients.builtin
      .query({
        query: avatar.getPer,
        variables: {},
        fetchPolicy: "no-cache",
      })
      .then((res) => {
        let data = res.data.userPreference.preferences;
        let obj = data.filter(t=>t.name == 'myAvatar')
        if(obj.length){
            commit("updateAvatar", {data: obj[0].valueString});
        }
      })
      .catch((error) => {
        // console.log(error);
      })
      .finally((res) => {
        state.avatarLoading = false;
      });

    },


    editAvatar({ state, commit }, { value }) {
        state.avatarLoading = true;
        let obj = {
            name: 'myAvatar',
            value
        }
        apolloProvider.clients.builtin
        .query({
          query: avatar.editPer,
          variables: obj,
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          let data = res.data.editUserPreference.valueString;
          commit("updateAvatar", {data});
          Message.success('头像更新成功~')
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally((res) => {
          state.avatarLoading = false;
        });
  
      }
  };

const mutations = {
  updateAvatar(state, {data}) {
    state.avatarData = data;
  },
  avatarDialogVisible(state, data){
    state.avatarDialog = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/avatar.js